import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  .mobile-icon {\n    width: 32px;\n    ",
        " {\n      display: none;\n    }\n  }\n  .desktop-icon {\n    width: 160px;\n    display: none;\n    ",
        " {\n      display: block;\n    }\n  }\n  .eye {\n    animation-delay: 20ms;\n  }\n  &:hover {\n    .eye {\n      transform-origin: center 60%;\n      animation-duration: 350ms;\n      animation-iteration-count: 1;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  overflow: hidden;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 30px 100px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  -webkit-box-pack: justify;\n  justify-content: space-between;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, 25%);\n  align-items: flex-start;\n  margin-bottom: 1rem;\n  @media screen and (max-width: 768px) {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 56px 40px 0px 0px;\n    margin-left: -2rem;\n    gap: 60px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  width: 400px;\n  gap: 10px;\n  flex-direction: column;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  text-decoration: none;\n  margin-bottom: 20px;\n  font-weight: 400;\n  .a {\n    color: #777e91;\n    height: 30px;\n    display: flex;\n    -webkit-box-pack: start;\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  border-width: 0 0 1px 1px solid #e6e8ec;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  font-weight: 700;\n  margin-bottom: 30px;\n  color: black;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  color: black;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 30px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  color: #000;\n  text-decoration: none;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { Link } from "../Link";
import FbIcon from "../Svg/FbIcon";
import TelegramIcon from "../Svg/TelegramIcon";
import TwitterIcon from "../Svg/TwitterIcon";
import WebsiteIcon from "../Svg/WebsiteIcon";
var MenuItem = function(_param) {
    var items = _param.items, isDark = _param.isDark, toggleTheme = _param.toggleTheme, currentLang = _param.currentLang, langs = _param.langs, setLang = _param.setLang, cakePriceUsd = _param.cakePriceUsd, buyCakeLabel = _param.buyCakeLabel, props = _object_without_properties(_param, [
        "items",
        "isDark",
        "toggleTheme",
        "currentLang",
        "langs",
        "setLang",
        "cakePriceUsd",
        "buyCakeLabel"
    ]);
    var textColor = isDark ? "#FFFFFF" : "#07194F";
    return /*#__PURE__*/ _jsxs(FooterStyle, {
        children: [
            /*#__PURE__*/ _jsx(Hr, {}),
            /*#__PURE__*/ _jsx(Container, {
                children: /*#__PURE__*/ _jsxs(FlexStyle, {
                    children: [
                        /*#__PURE__*/ _jsx(Col, {
                            children: /*#__PURE__*/ _jsx(StyledLink, {
                                as: "a",
                                href: "https://runtogether.net/",
                                target: "_blank",
                                children: /*#__PURE__*/ _jsx("img", {
                                    style: {
                                        width: "100px",
                                        height: "auto"
                                    },
                                    src: "/logo.png?version=1.2",
                                    alt: "logo"
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            children: /*#__PURE__*/ _jsxs(FlexUl, {
                                children: [
                                    /*#__PURE__*/ _jsx(Li, {
                                        children: /*#__PURE__*/ _jsx(CustomLink, {
                                            style: {
                                                textDecoration: "none"
                                            },
                                            href: "https://whitepaper.runtogether.net/about-run-together/general",
                                            target: "_blank",
                                            children: "Whitepaper"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs(Li, {
                                        children: [
                                            " ",
                                            /*#__PURE__*/ _jsx(CustomLink, {
                                                style: {
                                                    textDecoration: "none"
                                                },
                                                href: "https://runtogether.net/wp-content/uploads/2022/08/Pitchdeck-Run-Together-Eng.pdf",
                                                target: "_blank",
                                                children: "Pitchdeck"
                                            }),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Li, {
                                        children: [
                                            " ",
                                            /*#__PURE__*/ _jsx(CustomLink, {
                                                style: {
                                                    textDecoration: "none"
                                                },
                                                href: "https://bscscan.com/address/0xc643E83587818202E0fFf5eD96D10Abbc8Bb48e7",
                                                target: "_blank",
                                                children: "Smart Contract"
                                            }),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Li, {
                                        children: [
                                            " ",
                                            /*#__PURE__*/ _jsx(CustomLink, {
                                                style: {
                                                    textDecoration: "none"
                                                },
                                                href: "https://github.com/verichains/public-audit-reports/blob/main/Verichains%20Public%20Audit%20Report%20-%20RunTogether%20Token%20v2%20-%20v1.0.pdf",
                                                target: "_blank",
                                                children: "Audits"
                                            }),
                                            " "
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            children: /*#__PURE__*/ _jsxs(ContactRun, {
                                children: [
                                    /*#__PURE__*/ _jsx(Title, {
                                        children: "Contact"
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: "hello@runtogether.net"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsxs(Col, {
                            children: [
                                /*#__PURE__*/ _jsx(Title, {
                                    children: "Follow us"
                                }),
                                /*#__PURE__*/ _jsxs(List, {
                                    children: [
                                        /*#__PURE__*/ _jsx(FbIcon, {
                                            to: "https://www.facebook.com/Runtogether.official"
                                        }),
                                        /*#__PURE__*/ _jsx(TwitterIcon, {
                                            to: "https://twitter.com/RunTogether_Nft"
                                        }),
                                        /*#__PURE__*/ _jsx(TelegramIcon, {
                                            to: "https://t.me/Runtogethergroup"
                                        }),
                                        /*#__PURE__*/ _jsx(WebsiteIcon, {
                                            to: "https://runtogether.net/"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
export default MenuItem;
var StyledLink = styled("a").withConfig({
    componentId: "sc-4ab008bf-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.nav;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.nav;
});
var FooterStyle = styled.div.withConfig({
    componentId: "sc-4ab008bf-1"
})(_templateObject1());
var Container = styled.div.withConfig({
    componentId: "sc-4ab008bf-2"
})(_templateObject2());
var FlexStyle = styled.div.withConfig({
    componentId: "sc-4ab008bf-3"
})(_templateObject3());
var FlexUl = styled.ul.withConfig({
    componentId: "sc-4ab008bf-4"
})(_templateObject4());
var Li = styled.div.withConfig({
    componentId: "sc-4ab008bf-5"
})(_templateObject5());
var Col = styled.div.withConfig({
    componentId: "sc-4ab008bf-6"
})(_templateObject6());
var Title = styled.div.withConfig({
    componentId: "sc-4ab008bf-7"
})(_templateObject7());
var Text = styled.div.withConfig({
    componentId: "sc-4ab008bf-8"
})(_templateObject8());
var List = styled.div.withConfig({
    componentId: "sc-4ab008bf-9"
})(_templateObject9());
var ContactRun = styled.div.withConfig({
    componentId: "sc-4ab008bf-10"
})(_templateObject10());
var Hr = styled.hr.withConfig({
    componentId: "sc-4ab008bf-11"
})(_templateObject11());
var CustomLink = styled(Link).withConfig({
    componentId: "sc-4ab008bf-12"
})(_templateObject12());
